import { useState, useEffect, useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export function EntradaManualTab() {
  const { authAxios } = useAuth();
  const authAxiosRef = useRef(authAxios);
  authAxiosRef.current = authAxios;
  const [members, setMembers] = useState([]);
  const [form, setForm] = useState({ member_id: "", clock_in: "", clock_out: "", notes: "" });

  useEffect(() => {
    authAxiosRef.current.get("/deliverers/team/members").then(res => {
      setMembers(res.data.filter(m => m.invite_accepted));
    }).catch(() => {});
  }, []);

  const submit = async () => {
    if (!form.member_id || !form.clock_in || !form.clock_out) {
      toast.error("Preencha todos os campos"); return;
    }
    try {
      const member = members.find(m => m.id === form.member_id);
      await authAxios.post("/timeclock/manual", { ...form, member_name: member?.name || "" });
      toast.success("Registro adicionado!");
      setForm({ member_id: "", clock_in: "", clock_out: "", notes: "" });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro");
    }
  };

  return (
    <div className="space-y-4 max-w-lg" data-testid="manual-tab">
      <p className="text-sm text-muted-foreground">Adicionar registro de ponto manualmente (para ajustes)</p>
      <div className="space-y-3">
        <div>
          <Label className="text-xs">Funcionário</Label>
          <Select value={form.member_id} onValueChange={v => setForm({ ...form, member_id: v })}>
            <SelectTrigger data-testid="manual-member"><SelectValue placeholder="Selecionar..." /></SelectTrigger>
            <SelectContent>{members.map(m => <SelectItem key={m.id} value={m.id}>{m.name}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <Label className="text-xs">Entrada</Label>
            <Input type="datetime-local" value={form.clock_in} onChange={e => setForm({ ...form, clock_in: e.target.value })} data-testid="manual-clock-in" />
          </div>
          <div>
            <Label className="text-xs">Saída</Label>
            <Input type="datetime-local" value={form.clock_out} onChange={e => setForm({ ...form, clock_out: e.target.value })} data-testid="manual-clock-out" />
          </div>
        </div>
        <div>
          <Label className="text-xs">Notas</Label>
          <Input value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} placeholder="Motivo do ajuste" data-testid="manual-notes" />
        </div>
        <Button onClick={submit} className="w-full bg-emerald-600 hover:bg-emerald-700 gap-2" data-testid="manual-submit">
          <CheckCircle2 className="w-4 h-4" />Adicionar Registro
        </Button>
      </div>
    </div>
  );
}
